/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8
// Component: LCH5wX9ZcSAe

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frLTK57AGre4oWC8c14hh8/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicWhyRerum.module.css"; // plasmic-import: LCH5wX9ZcSAe/css

createPlasmicElementProxy;

export type PlasmicWhyRerum__VariantMembers = {};
export type PlasmicWhyRerum__VariantsArgs = {};
type VariantPropType = keyof PlasmicWhyRerum__VariantsArgs;
export const PlasmicWhyRerum__VariantProps = new Array<VariantPropType>();

export type PlasmicWhyRerum__ArgsType = {
  slot2?: React.ReactNode;
  children?: React.ReactNode;
  slot?: React.ReactNode;
};
type ArgPropType = keyof PlasmicWhyRerum__ArgsType;
export const PlasmicWhyRerum__ArgProps = new Array<ArgPropType>(
  "slot2",
  "children",
  "slot"
);

export type PlasmicWhyRerum__OverridesType = {
  root?: Flex__<"div">;
  h1?: Flex__<"h1">;
};

export interface DefaultWhyRerumProps {
  slot2?: React.ReactNode;
  children?: React.ReactNode;
  slot?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicWhyRerum__RenderFunc(props: {
  variants: PlasmicWhyRerum__VariantsArgs;
  args: PlasmicWhyRerum__ArgsType;
  overrides: PlasmicWhyRerum__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_frLTK57AGre4oWC8c14hh8",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__loD5Z)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"35%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            quality={100}
            src={{
              src: "/plasmic/fb_rerum/images/_1stIconPng.png",
              fullWidth: 405,
              fullHeight: 458,
              aspectRatio: undefined
            }}
          />
        ),

        value: args.slot2
      })}
      <h1
        data-plasmic-name={"h1"}
        data-plasmic-override={overrides.h1}
        className={classNames("all", "h1", "h1__frLTK", sty.h1)}
      >
        <div className={classNames("all", sty.freeBox__vaxvz)}>
          <div className={classNames("all", sty.freeBox___6ZXgJ)}>
            {renderPlasmicSlot({
              defaultContents: "Vypl\u0148te \u017e\u00e1dost snadno a rychle",
              value: args.children,
              className: classNames(sty.slotTargetChildren)
            })}
          </div>
        </div>
      </h1>
      <div className={classNames("all", sty.freeBox__pWdT1)}>
        <div className={classNames("all", sty.freeBox__oxFp)}>
          {renderPlasmicSlot({
            defaultContents:
              "Vypln\u011bn\u00ed \u017e\u00e1dosti nebylo nikdy jednodu\u0161\u0161\u00ed. Na\u0161i p\u016fj\u010dku Rerum m\u016f\u017eete z\u00edskat na p\u00e1r kliknut\u00ed z pohodl\u00ed va\u0161eho domova. V\u0161e o tom, jak \u017e\u00e1dost vyplnit, najdete zde: Jak na to",
            value: args.slot,
            className: classNames(sty.slotTargetSlot)
          })}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "h1"],
  h1: ["h1"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h1: "h1";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicWhyRerum__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicWhyRerum__VariantsArgs;
    args?: PlasmicWhyRerum__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicWhyRerum__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicWhyRerum__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWhyRerum__ArgProps,
          internalVariantPropNames: PlasmicWhyRerum__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWhyRerum__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWhyRerum";
  } else {
    func.displayName = `PlasmicWhyRerum.${nodeName}`;
  }
  return func;
}

export const PlasmicWhyRerum = Object.assign(
  // Top-level PlasmicWhyRerum renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h1: makeNodeComponent("h1"),

    // Metadata about props expected for PlasmicWhyRerum
    internalVariantProps: PlasmicWhyRerum__VariantProps,
    internalArgProps: PlasmicWhyRerum__ArgProps
  }
);

export default PlasmicWhyRerum;
/* prettier-ignore-end */
